import axios from 'axios';

export function postData(data) {
  return axios({
    method: 'post',
    url: `${process.env.GATSBY_FORM_ENDPOINTS_URL}${process.env.GATSBY_FORM_ENDPOINTS_WEBSITE_NAME}/subscribe`,
    data
  })
}